import React, {Component} from 'react'
import PropTypes from 'prop-types'

import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import {PageContainer} from '../../components/components'
import ProjectThumb from './ProjectThumb'
import {projectActions} from '../../core/actions'
import {titlePrefix} from '../../index'

const mapStateToProps = state => ({
    isLoadingProjects: state.project.isLoadingProjects,
    projects: state.project.projects,
    error: state.project.error,
    user: state.auth.user
})

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({...projectActions}, dispatch)
})

class Home extends Component {
    componentDidMount () {
        document.title = `${titlePrefix}Projects`
        if (this.props.projects.length === 0) this.props.getProjects()
    }

    render () {
        const {projects, isLoadingProjects, user} = this.props

        return (
            <PageContainer isLoadingContent={isLoadingProjects} loaderText={'Getting Projects'}>
                { projects.length !== 0 && projects.map((project, index) => <ProjectThumb user={user} key={index} projectData={project} />)}
            </PageContainer>
        )
    }
}

Home.propTypes = {
    classes: PropTypes.object,
    getProjects: PropTypes.func,
    projects: PropTypes.array,
    isLoadingProjects: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
